import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["selected", "toggleable"]
  static values = {
    show: { type: String, default: "true" },
    display: { type: String, default: "block" }
  }

  connect() {
    this.toggle()
  }

  toggle() {
    const selectedInput = this.hasSelectedTarget
      ? this.selectedTarget
      : this.element.querySelector('input[type="radio"]:checked'); // fallback when no selected target (e.g. legacy radio-only markup)
    const selectedValue = selectedInput?.type === "checkbox" ? selectedInput?.checked : selectedInput?.value;

    this.toggleableTargets.forEach(target => {
      const showValue = target.dataset.toggleShow ?? this.showValue
      const show = String(selectedValue) === String(showValue)
      target.style.display = show ? this.displayValue : "none"
      this.syncRequiredFields(target, show)
    })
  }

  // Keep HTML5 required in sync with visibility so hidden fields don't block submit.
  syncRequiredFields(container, show) {
    container.querySelectorAll("input, textarea, select").forEach((el) => {
      if (show) {
        if (el.dataset.wasRequired === "true") {
          el.required = true
          delete el.dataset.wasRequired
        }
      } else if (el.required) {
        el.dataset.wasRequired = "true"
        el.required = false
      }
    })
  }
}
